import { useAppTranslation } from '../i18n/useAppTranslation';
import { useState, useEffect } from 'react';
import { Box, Typography, Button, Link as MuiLink, Stack, Checkbox, FormControlLabel } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { isNativeUA, loadMetaPixel } from '../utils/metaPixel';
import { initAnalytics } from '../utils/analytics';
import { readPrivacy, savePrivacy, privacyBlocked, PRIVACY_KEY } from '../utils/privacyConsent';

const CookieBanner = () => {
  const { tr } = useAppTranslation();
  const {pathname}=useLocation();
  const [visible,setVisible]=useState(()=>!readPrivacy());
  const [audience,setAudience]=useState(()=>readPrivacy()?.audience || false);
  const [advertising,setAdvertising]=useState(()=>readPrivacy()?.advertising || false);
  const blocked=privacyBlocked();
  useEffect(()=>{
    let previous=readPrivacy();
    const sync=(event:StorageEvent)=>{
      if(event.key!==PRIVACY_KEY && event.key!==null)return;
      (window as any).__g1sportPrivacy=null;
      const choice=readPrivacy();
      if((previous?.audience && !choice?.audience)||(previous?.advertising && !choice?.advertising)){window.location.reload();return;}
      previous=choice;setVisible(!choice);setAudience(choice?.audience || false);setAdvertising(choice?.advertising || false);
      initAnalytics();loadMetaPixel();
    };
    window.addEventListener('storage',sync);return()=>window.removeEventListener('storage',sync);
  },[]);
  if(isNativeUA())return null;
  const choose=(analytics:boolean,ads:boolean)=>{
    const old=readPrivacy();
    savePrivacy(analytics,ads);setAudience(analytics);setAdvertising(ads);setVisible(false);
    if((old?.audience && !analytics)||(old?.advertising && !ads)){
      window.fbq?.('consent','revoke');window.location.reload();return;
    }
    initAnalytics();loadMetaPixel();
  };
  if(!visible) return ['/cookies','/confidentialite'].includes(pathname) ? <Box sx={{textAlign:'center',py:2}}><Button variant="outlined" onClick={()=>setVisible(true)}>Modifier mes préférences de confidentialité</Button></Box> : null;
  return <Box sx={{position:'fixed',bottom:{xs:8,sm:16},left:{xs:8,sm:16},right:{xs:8,sm:'auto'},maxWidth:{sm:460},zIndex:t=>t.zIndex.snackbar+1}}>
    {visible && <Box role="region" aria-label={tr("Préférences de confidentialité G1Sport")} sx={{p:2.5,mb:1,borderRadius:3,bgcolor:'background.paper',color:'text.primary',boxShadow:6,border:'1px solid',borderColor:'divider',maxHeight:'75vh',overflowY:'auto'}}>
      <Typography variant="subtitle1" fontWeight={800} gutterBottom>{tr("Vos préférences sur G1Sport")}</Typography>
      <Typography variant="body2" sx={{lineHeight:1.6}}>{tr("G1Sport utilise un stockage nécessaire à votre connexion. Vous choisissez séparément la mesure d’audience et la publicité. Vous pouvez modifier votre choix sur la page Confidentialité.")}</Typography>
      <Stack sx={{my:1.5}}>
        <FormControlLabel control={<Checkbox checked={audience && !blocked} disabled={blocked} onChange={e=>setAudience(e.target.checked)}/>} label={<Typography variant="body2"><strong>{tr("Mesure d’audience")}</strong><br/>{tr("Statistiques Umami et suivi des visites, sessions et temps actif de G1Sport.")}</Typography>}/>
        <FormControlLabel control={<Checkbox checked={advertising && !blocked} disabled={blocked} onChange={e=>setAdvertising(e.target.checked)}/>} label={<Typography variant="body2"><strong>{tr("Publicité Meta")}</strong><br/>{tr("Mesure de l’efficacité de nos campagnes publicitaires.")}</Typography>}/>
      </Stack>
      {blocked && <Typography variant="body2" sx={{mb:1}}>{tr("Votre préférence DNT/GPC désactive ces mesures facultatives.")}</Typography>}
      <MuiLink component={RouterLink} to="/cookies" sx={{fontSize:13,fontWeight:700}}>{tr("En savoir plus")}</MuiLink>
      <Stack direction="row" useFlexGap flexWrap="wrap" gap={1} sx={{mt:2}}>
        <Button variant="outlined" size="small" onClick={()=>choose(false,false)}>{tr("Tout refuser")}</Button>
        <Button variant="outlined" size="small" onClick={()=>choose(audience,advertising)}>{tr("Enregistrer mes choix")}</Button>
        {!blocked && <Button variant="contained" size="small" onClick={()=>choose(true,true)}>{tr("Tout accepter")}</Button>}
      </Stack>
    </Box>}
  </Box>;
};
export default CookieBanner;
